export default class Countdown {
    constructor($element) {
        this.$element = $element;
        let dateTime = new Date($element.attr('data-datetime'));
        this.countDownDate = new Date(dateTime).getTime();
        this.startCountdown();
    }

    startCountdown(){
        let me = this;
        setInterval(function(){
            let now = new Date().getTime();
            let timeleft = me.countDownDate - now;

            let days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
            let hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            let minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
            let seconds = Math.floor((timeleft % (1000 * 60)) / 1000);

            me.$element.find('.js-webinar-days').text(days);
            me.$element.find('.js-webinar-hours').text(hours);
            me.$element.find('.js-webinar-minutes').text(minutes);
            me.$element.find('.js-webinar-seconds').text(seconds);

        }, 1000);
    }
}
